const initialState = {
    rateFilteredListResponse: [],
    ratesListResponse: [],
    rateBachAllResponse: [],
    rateBachUpdatedResponse: [],
    rateMarketUpdatedResponse: [],
    rateMarketDeletedResponse: [],
    ratesResponse: [],
    ratesResponseSearchCopy: [],
    rateDetailResponse: [],
    errorRates: false,
    errorRatesSearchCopy: false,
    errorRateFilteredList: false,
    errorRatesBachAll: false,
    errorRatesBachUpdated: false,
    errorRatesMarketUpdated: false,
    errorRatesMarketDeleted: false,
    errorRatesList: false,
    errorEditRate: null,
    errorRateDetail: false,
    errorFileUpload: false,
    responseFileUploaded: [],
    errorJsonUpload: false,
    responseJsonUploaded: [],
    ratesDuplicateResponse: [],
    errorDuplicateRates: false,
    responseDownloadRate: [],
    errorDownloadRate: false,
    responseCheckReportRate: [],
    errorCheckReportRate: false,
    rateDeleteRelationsResponse: [],
    rateDeleteRelationsResponseError: false,
    rateCreateRelationsResponse: [],
    rateCreateRelationsResponseError: false,

    responseHashExportRates: [],
    responseUpdateReportRates: [],
    responseCheckReportRates: [],
    errorHashExportRates: false,
    errorCheckReportRates: false,
    errorUpdateReportRates: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "RESPONSE_DELETE_RATES_RELATIONS":
            newState.rateDeleteRelationsResponse = action.value;
            if (action.value.status === "ok") {
                newState.rateDeleteRelationsResponseError = false;
            } else {
                newState.rateDeleteRelationsResponseError = true;
            }
            break;
        case "RESPONSE_CREATE_RATES_RELATIONS":
            newState.rateCreateRelationsResponse = action.value;
            if (action.value.status === "ok") {
                newState.rateCreateRelationsResponseError = false;
            } else {
                newState.rateCreateRelationsResponseError = true;
            }
            break;
        case "GET_RATES_FILTERED_LIST":
            newState.rateFilteredListResponse = action.value;
            if (action.value === undefined) {
                newState.errorRateFilteredList = true;
            } else {
                newState.errorRateFilteredList = false;
            }
            break;
        case "GET_RESPONSE_BACH_UPDATE_RATES":
            newState.rateBachUpdatedResponse = action.value;
            if (action.value === undefined || !action.value.status) {
                newState.errorRatesBachUpdated = true;
            } else {
                newState.errorRatesBachUpdated = false;
            }
            break;
        case "RESPONSE_UPDATE_MARKET_RATES":
            newState.rateMarketUpdatedResponse = action.value;
            if (action.value.status === undefined) {
                newState.errorRatesMarketUpdated = true;
            } else {
                newState.errorRatesMarketUpdated = false;
            }
            break;
        case "GET_RESPONSE_All_UPDATE_RATES":
            newState.rateBachAllResponse = action.value;
            if (action.value === undefined) {
                newState.errorRatesBachAll = true;
            } else {
                newState.errorRatesBachAll = false;
            }
            break;
        case "GET_RESPONSE_RATES_LIST":
            newState.ratesListResponse = action.value;
            if (action.value === undefined) {
                newState.errorRatesList = true;
            } else {
                newState.errorRatesList = false;
            }
            break;
        case "GET_RATE_BY_ID":
            newState.ratesResponse = action.value;
            if (action.value === undefined) {
                newState.errorRates = true;
            } else {
                newState.errorRates = false;
            }
            break;
        case "GET_RATE_BY_ID_SEARCH_COPY":
            newState.ratesResponseSearchCopy = action.value
            if (action.value === undefined) {
                newState.errorRatesSearchCopy = true;
            } else {
                newState.errorRatesSearchCopy = false;
            }
            break;
        case "GET_RATE_DETAIL_RESPONSE":
            newState.rateDetailResponse = action.value;
            if (action.value === undefined) {
                newState.errorRateDetail = true;
            } else {
                newState.errorRateDetail = false;
            }
            break;
        case "RATE_EDIT_RESPONSE":
            newState.ratesResponse = action.value;
            if (action.value.updated_at === undefined) {
                newState.errorEditRate = true;
            } else {
                newState.errorEditRate = false;
            }
            break;
        case "RATE_FILE_RESPONSE":
            newState.responseFileUploaded = action.value;
            if (action.value === undefined) {
                newState.errorFileUpload = true;
            } else {
                newState.errorFileUpload = false;
            }
            break;
        case "RATE_JSON_RESPONSE":
            newState.responseJsonUploaded = action.value;
            if (action.value === undefined) {
                newState.errorJsonUpload = true;
            } else {
                newState.errorJsonUpload = false;
            }
            break;
        case "GET_DUPLICATE_RATE_REPONSE":
            newState.ratesDuplicateResponse = action.value;
            if (action.value === undefined) {
                newState.errorDuplicateRates = true;
            } else {
                newState.errorDuplicateRates = false;
            }
            break;
        case "GET_DOWNLOAD_RATE_REPONSE":
            if (action.value.status !== undefined) {
                if (action.value.status === 'ok') {
                    newState.responseDownloadRate = action.value;
                    newState.errorDownloadRate = false;
                } else if (action.value.status === 'error') {
                    newState.responseDownloadRate = action.value;
                    newState.errorDownloadRate = true;
                } else if (action.value.status === 'ko') {
                    newState.responseDownloadRate = action.value;
                    newState.errorDownloadRate = true;
                }
            } else {
                newState.responseDownloadRate = [];
                newState.errorDownloadRate = true;
            }
            break;
        case 'REPORT_EXPORT_RATE_RESPONSE':
            newState.responseCheckReportRate = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportRate = true;
            } else {
                newState.errorCheckReportRate = false;
            }
            break;
        case 'HASH_EXPORT_RATES_RESPONSE':
            newState.responseHashExportRates = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportRates = true;
            } else {
                newState.errorHashExportRates = false;
            }
            break;
        case 'REPORT_EXPORT_RATES_RESPONSE':
            newState.responseCheckReportRates = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportRates = true;
            } else {
                newState.errorCheckReportRates = false;
            }
            break;
        case 'UPDATE_EXPORT_RATES_RESPONSE':
            newState.responseUpdateReportRates = action.value;
            if (action.value.detail !== undefined) {
                newState.errorUpdateReportRates = true;
            } else {
                newState.errorUpdateReportRates = false;
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;